var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddedToMyAnalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0H1C0.44772 0 0 0.44772 0 1V20.2763C0 20.3465 0.01478 20.4159 0.04339 20.4801C0.15591 20.7322 0.45155 20.8455 0.70373 20.7329L9 17.0313L17.2963 20.7329C17.3604 20.7615 17.4298 20.7764 17.5 20.7764C17.7761 20.7764 18 20.5525 18 20.2763V1C18 0.44772 17.5523 0 17 0ZM10 5H8V8H5V10H8V13H10V10H13V8H10V5Z",
    fill: "#212836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddedToMyAnalog);
export default __webpack_public_path__ + "static/media/addedToMyAnalog.7a65671d1c5fd255530a6c7fc1c96312.svg";
export { ForwardRef as ReactComponent };